export enum Param {
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
  PRODUCT_ID = 'id',
}
